import { useSelector } from 'hooks';

export const isPaidUser = () => {
    const { isComplete, isAuthenticated } = useSelector((state) => state.auth);
    const { is_paid } = useSelector((state) => state.user);

    return isComplete && isAuthenticated && is_paid;
};
